import { render, staticRenderFns } from "./Out3rdPlace.vue?vue&type=template&id=ab5cc068&scoped=true"
import script from "./Out3rdPlace.vue?vue&type=script&lang=js"
export * from "./Out3rdPlace.vue?vue&type=script&lang=js"
import style0 from "./Out3rdPlace.vue?vue&type=style&index=0&id=ab5cc068&prod&lang=scss"
import style1 from "./Out3rdPlace.vue?vue&type=style&index=1&id=ab5cc068&prod&lang=scss&scoped=true"
import style2 from "./Out3rdPlace.vue?vue&type=style&index=2&id=ab5cc068&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab5cc068",
  null
  
)

export default component.exports